import { TYPE } from 'components/Button/Button'
import * as React from 'react'
import { DefaultContent } from 'react-content-engine'
import { SButton } from '../../routing/linkButton'
import { getNameWithTheme } from '../../routing/links'

const BookButton: React.FC = () => {
  return (
    <SButton
      type={TYPE.plain}
      cutOff={'none'}
      name={getNameWithTheme('customise')}
      className="is-followup-5"
    >
      <DefaultContent addNode contentKey="book-now">
        Book now
      </DefaultContent>
    </SButton>
  )
}
export default BookButton
